import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import CheckBox from "@pages/EverGreen/Components/Checkbox";
import OthersSpecify from "@pages/EverGreen/Components/Textarea";
import { Tooltip } from "@pages/EverGreen/Components/Tooltip";
import { trackOnFormStartOrSuccess } from "@pages/EverGreen/Helpers/analyticsHelper";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateSourceOfFunds,
  updateSourceOfFundsContent,
  updateSourceOfWealthContent,
  updateSourceOfwealth,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { SCREEN_SIZE } from "@static/screen-size";
import { EverGreenStyle } from "@utils/Style/everGreen";
import React, { useCallback, useRef, useState } from "react";

function SourceOfWealth() {
  const dispatch = useAvivaDispatch();
  const sow = useAvivaSelector(
    (state) => state.everGreenStep3.occupation.sourceOfWealth
  ) as unknown as Record<string, any>;
  const sourceOfFund = useAvivaSelector(
    (state) => state.everGreenStep3.occupation.sourceOfFunds
  ) as unknown as Record<string, any>;
  const declaration = useAvivaSelector(
    (state) => state.everGreenStep3.occupation
  );
  const [sowContent, setSowContent] = useState(
    useAvivaSelector(
      (state) => state.everGreenStep3.occupation.sourceOfWealthOthersContent
    )
  );
  const [sofContent, setSofContent] = useState(
    useAvivaSelector(
      (state) => state.everGreenStep3.occupation.sourceOfFundsOthersContent
    )
  );
  const updateSowContentTimer = useRef<any>(null);
  const updateSofContentTimer = useRef<any>(null);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      trackOnFormStartOrSuccess("DS_occupation_form")

      dispatch(
        updateSourceOfwealth({
          ...sow,
          [e.target.name]: !sow[e.target.name],
        })
      );
    },
    [sow]
  );

  const handleChangeSoF = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      trackOnFormStartOrSuccess("DS_occupation_form")

      dispatch(
        updateSourceOfFunds({
          ...sourceOfFund,
          [e.target.name]: !sourceOfFund[e.target.name],
        })
      );
    },
    [sourceOfFund]
  );

  const updateSowContent = useCallback((e) => {
    trackOnFormStartOrSuccess("DS_occupation_form")

    if (e.target.value.length > 50) {
      return;
    }
    setSowContent(e.target.value);
    clearTimeout(updateSowContentTimer.current);
    updateSowContentTimer.current = setTimeout(() => {
      dispatch(updateSourceOfWealthContent(e.target.value));
    }, 300);
  }, []);
  const updateSofContent = useCallback((e) => {
    trackOnFormStartOrSuccess("DS_occupation_form")

    if (e.target.value.length > 50) {
      return;
    }
    setSofContent(e.target.value);
    clearTimeout(updateSofContentTimer.current);
    updateSofContentTimer.current = setTimeout(() => {
      dispatch(updateSourceOfFundsContent(e.target.value));
    }, 300);
  }, []);

  const getSourceNameById = (
    source: "sourceOfWealthList" | "sourceOfFundsList",
    id: string
  ) => {
    if (source === "sourceOfFundsList") {
      return (
        declaration.sourceOfFundsList.find((item) => item.id === id)?.text || ""
      );
    }
    if (source === "sourceOfWealthList") {
      return (
        declaration.sourceOfWealthList.find((item) => item.id === id)?.text ||
        ""
      );
    }
    return "";
  };

  return (
    <>
      <Title>
        <span>Source of Wealth</span>

        <span>
          <Tooltip title="Source of Wealth" isIcon={true}>
            <p>This refers to the origin of your wealth.</p>
          </Tooltip>
        </span>
      </Title>
      <Grid>
        <CheckBox
          name="ET"
          onChange={handleChange}
          label={getSourceNameById("sourceOfWealthList", "ET")}
          checked={sow.ET}
        />
        <CheckBox
          name="Rental"
          onChange={handleChange}
          label={getSourceNameById("sourceOfWealthList", "Rental")}
          checked={sow.Rental}
        />
        <CheckBox
          name="Invest"
          onChange={handleChange}
          label={getSourceNameById("sourceOfWealthList", "Invest")}
          checked={sow.Invest}
        />
        <CheckBox
          name="Others"
          onChange={handleChange}
          label={getSourceNameById("sourceOfWealthList", "Others")}
          checked={sow.Others}
        />
      </Grid>
      {sow.Others && (
        <>
          <div
            style={{
              marginTop: "24px",
              marginBottom: "16px",
              fontSize: "14px",
              fontWeight: "500",
              color: EverGreenStyle.colors.grey[500],
            }}
          >
            Provide more details below:
          </div>
          <OthersSpecify
            maxLength={50}
            style={{
              color: EverGreenStyle.colors.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
            placeholder=""
            charLimitlabel="50"
            value={sowContent}
            onChange={updateSowContent}
          />
        </>
      )}
      <Title className={secondContainer}>
        <span>Source of Funds</span>

        <span>
          <Tooltip title="Source of Funds" isIcon={true}>
            <p>
            This refers to the origin of the funds that will be used to pay your premiums.
            </p>
          </Tooltip>
        </span>
      </Title>
      <Grid>
        <CheckBox
          name="ET2"
          onChange={handleChangeSoF}
          checked={sourceOfFund.ET2}
          label={getSourceNameById("sourceOfFundsList", "ET2")}
        />
        <CheckBox
          name="SaleOfProperty"
          onChange={handleChangeSoF}
          label={getSourceNameById("sourceOfFundsList", "SaleOfProperty")}
          checked={sourceOfFund.SaleOfProperty}
        />
        <CheckBox
          name="Savings"
          onChange={handleChangeSoF}
          label={getSourceNameById("sourceOfFundsList", "Savings")}
          checked={sourceOfFund.Savings}
        />
        <CheckBox
          name="MaturityOfPolicy"
          onChange={handleChangeSoF}
          label={getSourceNameById("sourceOfFundsList", "MaturityOfPolicy")}
          checked={sourceOfFund.MaturityOfPolicy}
        />
        <CheckBox
          name="Others2"
          onChange={handleChangeSoF}
          label={getSourceNameById("sourceOfFundsList", "Others2")}
          checked={sourceOfFund.Others2}
        />
      </Grid>
      {sourceOfFund.Others2 && (
        <>
          <div
            style={{
              marginTop: "24px",
              marginBottom: "16px",
              fontSize: "14px",
              fontWeight: "500",
              color: EverGreenStyle.colors.grey[500],
            }}
          >
            Provide more details below:
          </div>
          <OthersSpecify
            placeholder=""
            style={{
              color: EverGreenStyle.colors.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
            maxLength={50}
            charLimitlabel="50"
            value={sofContent}
            onChange={updateSofContent}
          />
        </>
      )}
    </>
  );
}

const secondContainer = css`
  margin-top: 48px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 24px;
  display: flex;
  gap: 8px;
  align-items: center;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 18px;
  }
`;
const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 0px;
    column-gap: 24px;
    div {
      margin: 20px 0px;
    }
  }
`;

export default SourceOfWealth;
